import api from './api';

export const exportService = {
  exportClients: async (format = 'csv') => {
    const response = await api.get('/export/clients', {
      params: { format },
      responseType: 'blob',
    });
    return response.data;
  },

  downloadBlob: (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
};
